export enum UserRol {
  ADMINISTRADOR = 1,
  MANAGER = 2,
  BASIC = 3
}
